/** "Hangar creates the EAS project" (api/openapi.yaml `/apps/{appId}/eas`). */
import { EasSetup, type EasProvisionRequest, type EasWebhookRequest } from '@hangar/shared';
import { api } from './client';

const enc = encodeURIComponent;

/** The app's EAS link and the app.json it needs (answered from Hangar's records; Expo is not called). */
export const getEasSetup = (appId: string) => api('GET', `/apps/${enc(appId)}/eas`, { schema: EasSetup });

/** Creates (or finds) the app's EAS project under the Expo account Malible manages. Idempotent; admin or the project's maintainer. */
export const provisionEas = (appId: string, body: EasProvisionRequest = {}) => api('POST', `/apps/${enc(appId)}/eas/provision`, { schema: EasSetup, body });

/** Registers (or repairs) Hangar's BUILD webhook on the app's EAS project, hand-linked ones included. Idempotent; admin or the project's maintainer. */
export const registerEasWebhook = (appId: string, body: EasWebhookRequest = {}) => api('POST', `/apps/${enc(appId)}/eas/webhook`, { schema: EasSetup, body });
